import { DatePicker, Progress, Typography } from "antd";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import styles from "./payment.module.css";
import CustomButton from "../../../../../../common/custom-button/custom-button";
import CustomTextfield from "../../../../../../common/input/custom-textfield/custom-textfield";
import { SearchOutlined } from "@ant-design/icons";
import CustomFilter from "../../../../../../components/custom-filter/custom-filter";
import CustomTable from "../../../../../../common/custom-table/custom-table";
import CustomDateRangePicker from "../../../../../../common/input/custom-daterange-picker/custom-daterange-picker";
import SVGIcon from "../../../../../../constants/SVGIcon";
import CustomStatsCard from "../../../../../../components/custom-stats-card/custom-stats-card";
import {
  fetchStudentPayments,
  getStudentPaymentHistoryForExport,
} from "../../../../../../services/student";
import { toast } from "react-toastify";

const { RangePicker } = DatePicker;

const Payment = ({ studentID }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [dateRange, setDateRange] = useState([
    dayjs().subtract(7, "days"),
    dayjs(),
  ]);
  const [totalFees, setTotalFees] = useState(0);
  const [feesReceived, setFeesReceived] = useState(0);
  const [loading, setLoading] = useState(false);
  const [paymentList, setPaymentList] = useState([]);
  const [filterValues, setFilterValues] = useState({
    status: [],
  });

  const filterData = [
    {
      id: "status",
      label: "Status",
      data: [],
    },
  ];

  useEffect(() => {
    studentID && getStudentPayments();
  }, [studentID]);

  const getStudentPayments = async () => {
    try {
      setLoading(true);
      const response = await fetchStudentPayments(studentID);
      if (response?.data) {
        setPaymentList(response?.data?.data?.payments);
        setTotalFees(response?.data?.data?.total_fees);
        setFeesReceived(response?.data?.data?.fees_received);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log("error", error);
    }
  };

  const onChangeFilter = (id, values) => {
    const tempData = { ...filterValues, [id]: values };
    setFilterValues(tempData);
  };

  const onFilterReset = () => {
    setFilterValues({
      status: [],
    });
  };

  const handleExportCSV = async () => {
    try {
      setLoading(true);
      const payload = {
        start_date: dateRange[0]?.format("YYYY-MM-DD"),
        end_date: dateRange[1]?.format("YYYY-MM-DD"),
        student_id: studentID,
      };
      const response = await getStudentPaymentHistoryForExport(payload);

      if (response?.status) {
        setLoading(false);
        const blob = new Blob([response?.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          `payment history for ${dateRange[0]?.format(
            "YYYY-MM-DD"
          )} to ${dateRange[1]?.format("YYYY-MM-DD")}.xlsx`
        );
        document.body.appendChild(link);
        link.click();
        link.remove();
      }
    } catch (error) {
      console.error(error);
      toast.error("Failed to export file.");
    }
  };

  const columns = [
    { title: "Payment Date", dataIndex: "payment_date", key: "payment_date" },
    { title: "Amount", dataIndex: "amount", key: "amount" },
    { title: "Purpose", dataIndex: "purpose", key: "purpose" },
    { title: "Payment Mode", dataIndex: "payment_mode", key: "payment_mode" },
    {
      title: "Transaction ID",
      dataIndex: "transaction_id",
      key: "transaction_id",
    },
  ];

  return (
    <div className={styles.mainContainer}>
      <div className={styles.statsGridContainer}>
        <div className={styles.statsGridItem}>
          <CustomStatsCard title={"TOTAL FEES"} value={`$${totalFees}`} />
        </div>
        <div className={styles.statsGridItem}>
          <CustomStatsCard title={"FEES RECEIVED"} value={`$${feesReceived}`} />
        </div>
      </div>
      <div className={styles.filterMainContainer}>
        <Typography className={styles.title}>Payment History</Typography>

        <div className={styles.filterContainer}>
          <div className={styles.firstDiv}>
            <div style={{ width: "100%" }}>
              <CustomTextfield
                suffix={<SearchOutlined style={{ color: "#98A2B3" }} />}
                id={"search"}
                value={searchTerm}
                placeholder="Search ..."
                className={styles.inputField}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>
            <CustomFilter
              width={"100%"}
              filterData={filterData}
              values={filterValues}
              onResetFilter={onFilterReset}
              onChange={(id, values) => onChangeFilter(id, values)}
            />
          </div>
          <div className={styles.firstDiv}>
            <div style={{ width: "100%" }}>
              <CustomDateRangePicker
                className={styles.dateRange}
                value={dateRange}
                onChange={(val) => setDateRange(val)}
              />
            </div>
            <div style={{ width: "100%" }}>
              <CustomButton
                title="Export CSV"
                className={styles.exportButton}
                onClick={handleExportCSV}
                icon={
                  <SVGIcon
                    name="export-file"
                    width="13"
                    height="16"
                    stroke="tnansparent"
                  />
                }
                iconPosition="end"
                style={{
                  background: "#F5F5F5",
                  color: "var(--primary-color)",
                }}
              />
            </div>
          </div>
        </div>
      </div>
      <CustomTable
        columns={columns}
        dataSource={paymentList}
        total={paymentList?.length}
        pagination={false}
        loading={loading}
      />
    </div>
  );
};

export default Payment;
